// extracted by mini-css-extract-plugin
export default {"inputWithLabel":"LabelContent-inputWithLabel_m6TrX","rowLabel":"LabelContent-rowLabel_pPd0T"};